import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'
import { TRANSFORMER, TRANSFORMERS } from '../../transformer'

export function isUppercase(s: string): boolean {
  if (!s) return false

  return s === s.toUpperCase() && s.length !== 1 && /[A-Z]/.test(s)
}

export function isLowercase(s: string): boolean {
  if (!s) return false

  return s === s.toLowerCase() && /[a-z]/.test(s)
}

export function findTracksWithAllSameCaseTitles(tracks: Track[], lowercase: boolean, uppercase: boolean): Track[] {
  return tracks.filter(t => ((uppercase && isUppercase(t.title)) || (lowercase && isLowercase(t.title))) && TRANSFORMER[TRANSFORMERS.CasingTitle].transformer(t, { values: [TrackFields.Title] }) !== t.title)
}
